import { WORKFLOW_DOCTYPE } from "../../../core/constants/workflow.constant";
import { TIER } from "../../../core/constants1";

export const isEmpty = (value) => {
    return value === undefined ||
        value === null ||
        (typeof value === 'object' && Object.keys(value).length === 0) || 
        (typeof value === 'string' && value.trim().length === 0);
}

// AB#40758: the card names the document only. The technicians assigned to it, their pay split
// and the service timers are internal; the API no longer sends them to the client portal.
export const renderTechnician = (item, companies) => {
	let text = '';
	const number = item.number.toString().padStart(4, '0');
	switch (item.docType) {
	case WORKFLOW_DOCTYPE.ESTIMATE:
		text = `Estimate #${number} by ${item.createdBy?.name || item.createdBy}`;
		break;
	case WORKFLOW_DOCTYPE.WORK_ORDER:
		text = `Work order #${number}`;
		break;
	case WORKFLOW_DOCTYPE.INVOICE: {
		let invoicePrefix = '';
		companies.forEach(element =>{
			if(element.company == item.company && element.prefix){
				invoicePrefix = element?.prefix || '';
				invoicePrefix = invoicePrefix.replaceAll('{CLIENT_ID}', (item.client?.clientID || ''));
			}
		})
		text = `Invoice ${invoicePrefix} #${number}`;
		break;
	}
	default:
		break;
	}

	return text;
};

export const accessWorkflow = (vendor) => {
    return vendor?.workflowManagement?.stages && (vendor?.stripe?.tier === TIER.PRO || vendor?.stripe?.tier === TIER.ENTERPRISE)
}

// AB#40825: the API's Stage.grouping enum allows 4 (VehicleReport). The board only fills estimate
// (1), work order (2) and invoice (3) columns, so a stage with any other grouping is never a column
// and never drives a document query. Duplicated from Web/admin-portal/src/utils/workflowStages.js
// (slices deploy separately, so they cannot share a module).
export const BOARD_STAGE_GROUPINGS = [1, 2, 3];

export const isBoardStage = (stage) => !!stage && BOARD_STAGE_GROUPINGS.includes(stage.grouping);

export const boardStages = (stages) => (stages || []).filter(isBoardStage);
